"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomizableCheckmark = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var constants_1 = require("../utils/constants");
/**
 * @internal
 */
exports.CustomizableCheckmark = function (_a) {
    var className = _a.className, width = _a.width, height = _a.height;
    var backgroundColor = "var(--gd-palette-primary-base, " + constants_1.GD_COLOR_HIGHLIGHT + ")";
    return (react_1.default.createElement("svg", { width: width, height: height, xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", className: "gd-customizable-checkmark " + className },
        react_1.default.createElement("g", { fill: "none" },
            react_1.default.createElement("g", { transform: "translate(-294.000000, -314.000000)", fill: "#14b2e2" },
                react_1.default.createElement("g", { transform: "translate(0.000000, 234.000000)" },
                    react_1.default.createElement("path", { d: "M298.166667,89.75 L294,85.6875 L295.666667,84.0625 L298.166667,86.5 L304.833333,80 L306.5,81.625 L298.166667,89.75 Z", fill: backgroundColor }))))));
};
exports.CustomizableCheckmark.defaultProps = {
    width: 13,
    height: 10,
};
//# sourceMappingURL=CustomizableCheckmark.js.map